import React from 'react';

let TooltipContext: React.Context<string>;
export class TooltipGetter {
    public tooltip: any;
    public async getTooltip() {
        this.tooltip = await fetch('assets/tooltip.txt').then((r) => r.text());
        TooltipContext = React.createContext(this.tooltip);
        return this.tooltip;
    }
}

const getTooltipContext = function () {
    return TooltipContext ?? React.createContext(new TooltipGetter().tooltip);
};
export default getTooltipContext;
